<div class="email-server" data-automation-id="email-server-and-notifications-container">
    <div class="header-bar top" data-automation-id="email-server-and-notifications-header">
        <button type="button" data-automation-id="email-server-and-notifications-save-button" class="primary-button"
            *ngIf="hasCreatePermissions" (click)="saveChanges()" [disabled]="!isDirty || isSaveDisabled()">Save</button>
        <button type="button" data-automation-id="email-server-and-notifications-discard-changes-button"
            *ngIf="hasCreatePermissions" class="secondary-button" (click)="discardChanges()"
            [disabled]="isDiscardDisabled()">Discard
            Changes</button>
        <button type="button" class="help-button" data-automation-id="email-server-and-notifications-help-button"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <form class="content" #contentForm="ngForm" data-automation-id="email-server-and-notifications-content"
        [resBusySpinner]="isBusy" [message]="isBusyMessage">

        <div class="settings-panel-header">Email Server Configuration</div>

        <div class="modal-row">
            <div class="modal-row-column-auto" [ngStyle]="{'width' : '120px'}">
                <label data-automation-id="email-server-configuration-smtp-host-label" requiredAsterisk>SMTP Host:
                </label>
            </div>
            <div class="modal-row-column-auto">
                <input type="text" name="smtpHost" class="host-ip-width" [(ngModel)]="viewModel.model.smtpHostId"
                    [disabled]="!hasCreatePermissions" [value]="viewModel.model.smtpHostId"
                    data-automation-id="email-server-configuration-smtp-host-input" (ngModelChange)="onChange()"
                    [(resScrollablePopover)]="hostId.invalid" [hasInputError]="hostId.invalid" formErrorInput
                    placeholder="IP Address or Host Name"
                    (blur)="updateConfig($event, 'hostId', 'blur'); validateIP($event)"
                    (input)="updateConfig($event, 'hostId'); validateIP($event)"
                    [popoverErrorMessage]="hostId.errorMessage" popoverType="error" popoverPlacement="right"
                    formErrorInput (focusin)="hostId.invalid = false"
                    [popoverAutomationId]="'email-server-configuration-smtp-host-error-message'" [isSingleLine]="true">
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-auto" [ngStyle]="{'width' : '120px'}">
                <label data-automation-id="email-server-configuration-smtp-port-label" requiredAsterisk>SMTP Host Port:
                </label>
            </div>
            <div class="modal-row-column-auto">
                <input type="text" name="hostPort" class="host-port-width" [(ngModel)]="viewModel.model.smtpHostPort"
                    [disabled]="!hasCreatePermissions" [value]="viewModel.model.smtpHostPort"
                    (keypress)="restrictPort($event)" data-automation-id="email-server-configuration-smtp-port-input"
                    (ngModelChange)="onChange()" [(resScrollablePopover)]="hostPort.invalid"
                    [hasInputError]="hostPort.invalid" formErrorInput (blur)="updateConfig($event, 'hostPort', 'blur')"
                    (focusin)="hostPort.invalid = false"
                    (input)="updateConfig($event, 'hostPort');validateInputOnPaste($event, 'smtpHostPort')"
                    [popoverErrorMessage]="hostPort.errorMessage" popoverType="error" popoverPlacement="right"
                    formErrorInput [popoverAutomationId]="'email-server-configuration-smtp-host-port-error-message'"
                    [isSingleLine]="true">
            </div>
            <div class="modal-row-column-auto">
                <res-custom-checkbox name="useSsl" [(ngModel)]="viewModel.model.isUsingSsl"
                    [disabled]="!hasCreatePermissions" (ngModelChange)="setSmtpHostPort($event)"
                    automationId="email-server-configuration-use-ssl" content="Use SSL">
                </res-custom-checkbox>
            </div>
        </div>

        <div class="modal-row">
            <div class="modal-row-column-auto">
                <res-custom-checkbox name="mailSmtpAuth" automationId="email-server-configuration-use-authentication"
                    [(ngModel)]="viewModel.model.mailSmtpAuth" content="Use SMTP Authentication"
                    (ngModelChange)="onChange()" [isDisabled]="isSMTPAuthenticationDisabled() || !hasCreatePermissions">
                </res-custom-checkbox>
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-auto" [ngStyle]="{'width' : '70px'}">
                <label data-automation-id="email-server-configuration-smtp-authentication--user-id-label"
                    [class.disabled]="!viewModel.model.mailSmtpAuth || isSMTPAuthenticationDisabled() || !hasCreatePermissions"
                    requiredAsterisk
                    [isDisabled]="!viewModel.model.mailSmtpAuth || isSMTPAuthenticationDisabled() || !hasCreatePermissions">User
                    ID:
                </label>
            </div>
            <div class="modal-row-column-auto">
                <input type="text" name="mailUserId" class="generic-width" [(ngModel)]="viewModel.model.mailUserId"
                    [value]="viewModel.model.mailUserId"
                    data-automation-id="email-server-configuration-smtp-authentication-user-id-input"
                    [disabled]="!viewModel.model.mailSmtpAuth || isSMTPAuthenticationDisabled() || !hasCreatePermissions"
                    (ngModelChange)="onChange()" [(resScrollablePopover)]="mailUserId.invalid"
                    [hasInputError]="mailUserId.invalid" formErrorInput (focusin)="mailUserId.invalid = false"
                    (blur)="updateConfig($event, 'mailUserId', 'blur')" (input)="updateConfig($event, 'mailUserId')"
                    [popoverErrorMessage]="mailUserId.errorMessage" popoverType="error" popoverPlacement="right"
                    formErrorInput
                    [popoverAutomationId]="'email-server-configuration-smtp-authentication-user-id-error-message'"
                    [isSingleLine]="true">
            </div>
        </div>
        <div class="modal-row bottom-margin">
            <div class="modal-row-column-auto" [ngStyle]="{'width' : '70px'}">
                <label data-automation-id="email-server-configuration-smtp-host-label"
                    [class.disabled]="!viewModel.model.mailSmtpAuth || isSMTPAuthenticationDisabled() || !hasCreatePermissions"
                    requiredAsterisk
                    [isDisabled]="!viewModel.model.mailSmtpAuth || isSMTPAuthenticationDisabled() || !hasCreatePermissions">Password:
                </label>
            </div>
            <div class="modal-row-column-auto">
                <input type="password" #mailUserPasswordInput name="mailUserPasswordInput" class="generic-width" ngModel
                    [value]="viewModel.model.mailUserPassword"
                    data-automation-id="email-server-configuration-smtp-password-input" resIconSwitch
                    initClass="fa fa-eye" switchClass="fa fa-eye-slash" (focusin)="mailUserPassword.invalid = false"
                    [disabled]="!viewModel.model.mailSmtpAuth || isSMTPAuthenticationDisabled() || !hasCreatePermissions"
                    elementAttributeName="type" elementAttributeValue="text" (ngModelChange)="onChange()"
                    [(resScrollablePopover)]="mailUserPassword.invalid" [hasInputError]="mailUserPassword.invalid"
                    formErrorInput (blur)="updateConfig($event, 'mailUserPassword', 'blur')"
                    (input)="updateConfig($event, 'mailUserPassword')"
                    [popoverErrorMessage]="mailUserPassword.errorMessage" popoverType="error" popoverPlacement="right"
                    formErrorInput
                    [popoverAutomationId]="'email-server-configuration-smtp-authentication-user-password-error-message'"
                    [isSingleLine]="true">
            </div>
        </div>

        <div class="settings-panel-header top-border">Email Notifications</div>

        <div class="notification-container">
            <div class="modal-row">
                <div class="notification-content">
                    <label data-automation-id="email-server-configuration-smtp-host-label">Send Email Notifications
                        to:</label>
                </div>
                <div class="modal-row-column-auto">
                    <button type="button" data-automation-id="email-server-and-notifications-discard-changes-button"
                        class="secondary-button btn-margin" (click)="sendTestEmail('all')" *ngIf="hasCreatePermissions"
                        [disabled]="(isEmailAllDisabled || !isDataSaved()) || !notificationAddressList || notificationAddressList?.length === 1 ">Send
                        Test Email to All</button>
                </div>
            </div>

            <div class="line-spacer"></div>
        </div>

        <div class="key-value-container">
            <res-key-value-list #queriesKeyValue
                [placeholderField1]='"Enter an Email address or paste multiple addresses ..."'
                [isDisabled]="!hasCreatePermissions" [rows]="notificationAddressList" [queryColumnHidden]="true"
                automationId="email-addresses-notifications-" [suffixTemplate]="suffixTemplate" [isEmail]="true"
                [showClearNameBtn]="true">
            </res-key-value-list>
            <ng-template #suffixTemplate let-row="row" let-i="i">
                <div class="line-container">
                    <button type="button" data-automation-id="email-server-and-notifications-discard-changes-button"
                        class="secondary-button" (click)="sendTestEmail(row)" *ngIf="hasCreatePermissions"
                        [disabled]="isEmailSendTestDisabled(i) || !isDataSaved()">Send
                        Test
                        Email</button>
                </div>
            </ng-template>
        </div>
    </form>
</div>